export class VersionConstant {
  public static v1 = "api/v1/";
}
